import { createSlice } from '@reduxjs/toolkit';

const matchesSlice = createSlice({
  name: 'matches',
  initialState: {
    list: [],
    actionHistory: [], // For undo functionality: { profile, action, timestamp }
    refreshCounter: 0, // Increment to force reload
    recentlyActedIds: [], // Track IDs acted on recently to prevent race condition
    exhausted: false, // True when no more matches available
    loading: false, // True when loading more matches
  },
  reducers: {
    setMatchList: (state, action) => {
      state.list = action.payload;
    },
    appendMatches: (state, action) => {
      // Append new matches without duplicates
      const existingIds = new Set(state.list.map(m => m.id));
      const newMatches = action.payload.filter(m => !existingIds.has(m.id));
      state.list = [...state.list, ...newMatches];
    },
    replaceMatches: (state, action) => {
      state.list = action.payload;
      state.exhausted = false;
    },
    removeMatch: (state, action) => {
      state.list = state.list.filter((m) => m.id !== action.payload);
    },
    clearMatches: (state) => {
      state.list = [];
    },
    pushAction: (state, action) => {
      state.actionHistory.push({ ...action.payload, timestamp: Date.now() });
    },
    popAction: (state) => {
      state.actionHistory.pop();
    },
    clearActionHistory: (state) => {
      state.actionHistory = [];
    },
    refreshMatches: (state) => {
      state.refreshCounter += 1;
    },
    addRecentlyActedId: (state, action) => {
      if (!state.recentlyActedIds.includes(action.payload)) {
        state.recentlyActedIds.push(action.payload);
      }
    },
    clearRecentlyActedIds: (state) => {
      state.recentlyActedIds = [];
    },
    setExhausted: (state, action) => {
      state.exhausted = action.payload;
    },
    resetExhausted: (state) => {
      state.exhausted = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setMatchList, appendMatches, replaceMatches, removeMatch, clearMatches, pushAction, popAction, clearActionHistory, refreshMatches, addRecentlyActedId, clearRecentlyActedIds, setExhausted, resetExhausted, setLoading } = matchesSlice.actions;
export default matchesSlice.reducer;
